import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      width: `300px`,
      flexShrink: 0,
    },
    icondrawer:{
      width: 50
    }, 
    drawerPaper: {
      paddingBottom: '50px !important',
      backgroundColor: "#8080800f !important",
      top: '20px !important',
      left: '20px !important',
      bottom: '20px !important',
      border: '0.3px  rgba(0, 0, 0, 0.12)',
      borderRadius: '10px !important',
      marginRight: '20px !important',
      height: '700px !important',
    },
    drawerHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
      fontSize: 20,
      // width: 280,
      paddingLeft: 24,
      '& img': {
        width: 36,
        height: 36,
        marginRight: 16,
      },
    },
    drawerHeaderOpen: {
      display: 'flex',
      justifyContent: 'space-between !important',
      alignItems: 'center',
      marginLeft:20,
    },
    item: {
      display: 'block',
      paddingTop: 0,
      paddingBottom: 0,
    },
    selecteditem:{
      backgroundColor: '#7152F30D !important' ,
      borderLeft: '4px solid #7152F3 !important',
      borderRadius:'4px !important',
     
    },
    itemLeaf: {
      display: 'flex',
      paddingLeft: 10,
      paddingRight: 10,
    },
    button: {
      color: theme.palette.text.secondary,
      padding: '10px 8px',
      justifyContent: 'flex-start',
      textTransform: 'none',
      letterSpacing: 0,
      width: '100%',
    },
    buttonLeaf: {
      display: 'flex',
      color: theme.palette.text.secondary,
      padding: '10px 8px',
      justifyContent: 'flex-start',
      textTransform: 'none',
      letterSpacing: 0,
      width: '100%',
      fontWeight: 400,
      '&.depth-0': {
        '& $title': {
          fontWeight: theme.typography.fontWeightMedium,
        },
      },
      '&:hover': {
        textDecoration: 'none',
      },
    },
    icon: {
      display: 'flex',
      alignItems: 'center',
      marginRight: theme.spacing(1),
    },
    title: {
      marginRight: 'auto',
      color: '#16151C !important',
    },
    active: {
      color: theme.palette.secondary.main,
      '& $title': {
        fontWeight: theme.typography.fontWeightMedium,
      },
      '& $icon': {
        color: theme.palette.secondary.main,
      },
    },
    navBar_link: {
      color: 'inherit',
      display: 'flex',
      justifyContent: 'center',
      textDecoration: 'none',
    },
    version: {
      fontSize: 12,
    },
  }),
);

export default useStyles;
